import { gql } from 'graphql-request'
import { GenericBlock } from '../generic'
import { ExcludedPlatforms } from 'app/types/excludedPlatforms'
import { ColorEnum } from 'app/utils/mapColors'

export const benefitsBannerFragment = gql`
  fragment benefitsBannerFragment on BenefitsBanner {
    id
    benefits {
      text
      backgroundColour
      foregroundColour
      id
    }
    ctaLabel
    ctaLink
    excludedPlatforms {
      ios
      android
      web
    }
  }
`

export interface BenefitsBanner extends GenericBlock<'BenefitsBanner'> {
  benefits: {
    text: string
    backgroundColour: ColorEnum
    foregroundColour: ColorEnum
    id: string
  }[]
  ctaLabel: string
  ctaLink: string
  excludedPlatforms: ExcludedPlatforms
}
